/*!
 * ContextMenu - jQuery plugin for right-click context menus
 *
 * Author: Chris Domigan
 * Contributors: Dan G. Switzer, II
 * Parts of this plugin are inspired by Joern Zaefferer's Tooltip plugin
 *
 * Dual licensed under the MIT and GPL licenses:
 *   http://www.opensource.org/licenses/mit-license.php
 *   http://www.gnu.org/licenses/gpl.html
 *
 * Version: r2
 * Date: 16 July 2007
 *
 * For documentation visit http://www.trendskitchens.co.nz/jquery/contextmenu/
 *
 * RF 11/2008:
 * - added onHideMenu option (in practice it hides the "input blocking" layer which was shown at onShowMenu)
 * - added keypressed event to hide menu
 * RF 02/2010:
 * - keep menu on-screen (adjust position if menu reaches below bottom or right document border)
 * RF 03/2011:
 * - added separator entries
 * - removed inline css
 */
( function( factory ) {
	if( typeof define === 'function' && define.amd ) {
		define( ['jquery'], function( jQuery ) {
			return factory( jQuery, window );
		} );
	} else if( typeof exports === 'object' && module.exports ) {
		module.exports = factory( require( 'jquery' ), window );
	} else {
		factory( jQuery, window );
	}
}( function( $, window, undefined ) {
	"use strict";

	var trigger, content;
	var hash = {};
	var defaults = {
		eventPosX: 'pageX',
		eventPosY: 'pageY',
		shadow: true,
		onContextMenu: null,
		onShowMenu: null,
		onHideMenu: null,
		appendTo: null
	};

	$.fn.contextMenu = function( id, options ) {
		if( hash[id] !== undefined ) {
			hash[id].menu.remove();
			if( hash[id].shadow ) hash[id].shadowElem.remove();
		}
		var cur = {
			id: id,
			bindings: options.bindings || {},
			shadow: options.shadow || options.shadow === false ? options.shadow : defaults.shadow,
			onContextMenu: options.onContextMenu || defaults.onContextMenu,
			onShowMenu: options.onShowMenu || defaults.onShowMenu,
			onHideMenu: options.onHideMenu || defaults.onHideMenu,
			eventPosX: options.eventPosX || defaults.eventPosX,
			eventPosY: options.eventPosY || defaults.eventPosY,
			trigger: null,
			menu: null,
			shadowElem: null,
			appendTo: options.appendTo || defaults.appendTo || 'body'
		};
		if( typeof cur.appendTo === 'string' ) cur.appendTo = $( cur.appendTo );

		cur.menu = $( '<div id="' + id + '"></div>' )
			.hide()
			.css( { position: 'absolute', zIndex: '500' } )
			.appendTo( cur.appendTo )
			.on( 'click.jqContextMenu', function( e ) {
				e.stopPropagation();
			} );
		if( cur.shadow ) {
			cur.shadowElem = $( '<div class="contextmenu-background-custom"></div>' )
				.css( { position: 'absolute', opacity: 0.2, zIndex: 499 } )
				.appendTo( cur.appendTo )
				.hide();
		}
		hash[id] = cur;

		//var index = hash.length - 1;
		var index = id;
		$( this ).on( 'contextmenu.jqContextMenu', function( e ) {
			// Check if onContextMenu() defined
			var bShowContext = ( !!hash[index].onContextMenu ) ? hash[index].onContextMenu( e ) : true;
			hash[index].trigger = this;
			if( bShowContext ) display( index, this, e, options );
			e.preventDefault();
			e.stopPropagation();
			return false;
		} );
		return this;
	};

	function display( index, trigger, e, options ) {
		var cur = hash[index];
		content = $( '#' + cur.id ).find( 'ul:first' ).clone( true );

		// Send the content to the menu
		cur.menu.html( content );

		// if there's an onShowMenu, run it now -- must run after content has been added
		// if you try to alter the content variable before the menu.html(), IE6 has issues
		// updating the content
		if( !!cur.onShowMenu ) cur.menu = cur.onShowMenu( e, cur.menu );

		var n = 1;
		$.each( cur.bindings, function( id, func ) {
			$( '#' + id, cur.menu )
				.attr( 'tabindex', n++ )
				.on( 'click.jqContextMenu', function( e ) {
					hide( cur );
					//func(trigger);
					func( cur.trigger );
				} );
		} );

		var page_w = cur.appendTo.width();
		var page_h = cur.appendTo.height();
		var mn_w = cur.menu.width();
		var mn_h = cur.menu.height();
		var mn_x = e[cur.eventPosX] + 2;
		var mn_y = e[cur.eventPosY] + 2;

		// console.log({
		// 	mn_x,
		// 	o_x: cur.appendTo.offset().left,
		// 	page_w,
		// 	mn_w,

		// 	mn_y,
		// 	o_y: cur.appendTo.offset().top,
		// 	page_h,
		// 	mn_h
		// });

		mn_x -= cur.appendTo.offset().left;
		mn_y -= cur.appendTo.offset().top;

		// fit into bounds of options.appendTo element
		var pad = 2;
		if( mn_x > page_w - pad - mn_w ) mn_x = page_w - pad - mn_w;
		if( mn_x < pad ) mn_x = pad;
		if( mn_y > page_h - pad - mn_h ) mn_y = page_h - pad - mn_h;
		if( mn_y < pad ) mn_y = pad;

		// console.log({
		// 	mn_x,
		// 	o_x: cur.appendTo.offset().left,
		// 	mn_y,
		// 	o_y: cur.appendTo.offset().top
		// });
		// mn_x -= cur.appendTo.offset().left;
		// mn_y -= cur.appendTo.offset().top;

		cur.menu.css( { 'left': mn_x, 'top': mn_y, display: 'block' } );
		if( cur.shadow ) cur.shadowElem.css( { width: mn_w, height: mn_h, left: mn_x + 4, top: mn_y + 4, display: 'block' } );

		var tb_action_nodes = $( 'li:not(.separator)', cur.menu ).filter( ':visible' ),
			focus_node = $( '#media-ctxm-open,#media-ctxm-cat-open' );
		if( focus_node.length === 0 ) focus_node = tb_action_nodes.first();
		focus_node.focus();

		$( document )
			.one( 'click.jqContextMenu', cur, hide )
			//.one( 'contextmenu.jqContextMenu', cur, hide )
			.one( 'keydown.jqContextMenu', cur, keydownhandler )
			.one( 'mousedown.jqContextMenu', cur, mousedownhandler );
	}

	function hide( e ) {
		var cur = e.data ? e.data : e;
		if( !!cur.onHideMenu ) cur.onHideMenu( cur.menu );
		cur.menu.hide();
		cur.shadowElem.hide();
		$( document ).off( '.jqContextMenu' );
	}

	function keydownhandler( e ) {
		var cur = e.data ? e.data : e;
		//console.log('keydownhandler',e);
		/*
		if( e.which == 27 ) hide(e);//$(document).click();
		//else if( e.which == 38 ) {} // todo: up-arrow
		//else if( e.which == 40 ) {} // todo: down-arrow
		else $(document).one( 'keydown.jqContextMenu', cur, keydownhandler );
		*/
		var tb_action_nodes = $( '#' + cur.id + ' li:not(.separator)' ).filter( ':visible' ),
			focused_node = tb_action_nodes.filter( ':focus' ),
			focus_id = focused_node.prop( 'id' ),
			focus_idx = 0,
			tb_action_ids = [];
		tb_action_nodes.each( function( idx ) {
			var id = $( this ).prop( 'id' );
			tb_action_ids.push( id );
			if( id == focus_id ) focus_idx = idx;
		} );

		var bind_again = false;
		switch( e.which ) {
			case 9: // tab
				if( e.shiftKey ) new_focus_idx = ( focus_idx - 1 + tb_action_ids.length ) % tb_action_ids.length;
				else new_focus_idx = ( focus_idx + 1 ) % tb_action_ids.length;
				tb_action_nodes.eq( new_focus_idx ).focus();
				e.preventDefault();
				bind_again = true;
				break;
			case 37: // left
				new_focus_idx = ( focus_idx - 1 + tb_action_ids.length ) % tb_action_ids.length;
				tb_action_nodes.eq( new_focus_idx ).focus();
				bind_again = true;
				break;
			case 39: // right
				new_focus_idx = ( focus_idx + 1 ) % tb_action_ids.length;
				tb_action_nodes.eq( new_focus_idx ).focus();
				bind_again = true;
				break;
			case 38: // up
				new_focus_idx = ( focus_idx - 1 + tb_action_ids.length ) % tb_action_ids.length;
				tb_action_nodes.eq( new_focus_idx ).focus();
				bind_again = true;
				break;
			case 40: // down
				new_focus_idx = ( focus_idx + 1 ) % tb_action_ids.length;
				tb_action_nodes.eq( new_focus_idx ).focus();
				bind_again = true;
				break;
			case 13: // enter
			case 32: // space
				if( cur.bindings.hasOwnProperty( focus_id ) ) {
					var fn = cur.bindings[focus_id];
					hide( e );
					fn( cur.trigger );
					e.preventDefault();
					return false;
				}
				bind_again = true;
				break;
			case 27: // escape
			case 77: // M
				hide( e );
				e.preventDefault();
				return false;
		}

		if( bind_again ) {
			$( document ).one( 'keydown.jqContextMenu', cur, keydownhandler );
			return false;
		}
	}

	function mousedownhandler( e ) {
		var cur = e.data ? e.data : e;
		if( $( e.target ).closest( '#' + cur.id ).length === 0 ) {
			//console.log('mousedown outside of jqContextMenu',cur,e);
			hide( e );
		} else {
			//console.log('mousedown in jqContextMenu',cur,e);
			$( document ).one( 'mousedown.jqContextMenu', cur, mousedownhandler );
		}
	}

	// Apply defaults
	$.contextMenu = {
		defaults: function( userDefaults ) {
			$.each( userDefaults, function( i, val ) {
				if( typeof val == 'object' && defaults[i] ) {
					$.extend( defaults[i], val );
				} else defaults[i] = val;
			} );
		}
	};
} ) );
